import React from 'react';
import { HomeBanner } from '../../components/home/homeBanner';
import { CategoryAuctionsNew } from './components/CatergoryAuctions';
import PartnersSection from './pages/Landing/components/OurPartners';
import AppDownloadSection from './pages/Landing/components/AppDownloadSection';

export class Homepage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />
        {/* <CategorySearch /> */}
        <CategoryAuctionsNew />
        {/* <BeingPart /> */}
        <PartnersSection />
        <AppDownloadSection />
      </div>
    );
  }
}
